import type {World} from './types';
import {reachesPanelUnlock} from './paint';

export const NEIGHBORHOOD_ENDING=['Neighborhood complete','New development coming soon'] as const;
/** One completion state for the physical boundary and existing street map. */
export function isNeighborhoodComplete(world:Pick<World,'blocks'|'frontier'|'panelProgress'>):boolean {
  const assignment=world.blocks.find(block=>block.candidate?.assignment)?.candidate?.assignment;
  const progress=world.panelProgress.find(progress=>progress.blockId===world.frontier);
  return !!assignment&&world.frontier===assignment.count-1&&!!progress&&reachesPanelUnlock(progress.qualifiedPanels,progress.totalPanels);
}
